var map = {
	"./dashTabIconBCH.png": 1104,
	"./dashTabIconBTC.png": 1105,
	"./dashTabIconCELO.png": 1106,
	"./dashTabIconDASH.png": 1107,
	"./dashTabIconETH.png": 1108,
	"./dashTabIconLTC.png": 1109,
	"./dashTabIconRIPPLE.png": 1110,
	"./dashTabIconTRX.png": 1111,
	"./dashTabIconUSDT.png": 1112,
	"./dashTabIconXLM.png": 1113,
	"./dashTabIconXLS.png": 1114,
	"./dashTabIconXRP.png": 1115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1103;